import React, { forwardRef, useState } from 'react';
import axios from 'axios';
import { SurveyStep } from './SurveyStep';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

const readUtm = () => {
  const p = new URLSearchParams(window.location.search);
  const fresh = { utm_source: p.get('utm_source'), utm_campaign: p.get('utm_campaign') };
  if (fresh.utm_source || fresh.utm_campaign) sessionStorage.setItem('fm_utm', JSON.stringify(fresh));
  try { return JSON.parse(sessionStorage.getItem('fm_utm')) || {}; } catch { return {}; }
};

export const SignUpFlow = forwardRef(({ pendingRole }, inputRef) => {
  const [step, setStep] = useState('email');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [record, setRecord] = useState(null);
  const [utm] = useState(readUtm);

  const join = async (e) => {
    e.preventDefault();
    setError('');
    const value = email.trim();
    if (!EMAIL_RE.test(value)) { setError('Please enter a valid email address.'); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/waitlist/join`, { email: value, role: pendingRole || null, ...utm });
      setRecord({ id: data.id, token: data.token, role: data.role });
      setStep('survey');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  const send = async (answers) => {
    setBusy(true);
    try { await axios.post(`${API}/waitlist/update`, { id: record.id, token: record.token, ...answers }); } catch { /* answers are optional */ }
    setBusy(false);
    setStep('thanks');
  };

  const skip = () => {
    axios.post(`${API}/waitlist/skip`, { id: record.id, token: record.token }).catch(() => {});
    setStep('thanks');
  };

  if (step === 'survey') return <SurveyStep initialRole={record.role} busy={busy} onSend={send} onSkip={skip} />;
  if (step === 'thanks') {
    return (
      <div className="fm-panel" data-testid="thanks-panel">
        <h2 className="fm-panel-h">Thank you.</h2>
        <p className="fm-panel-p">You're a founding member. We'll email you before launch with your discounted price.</p>
      </div>
    );
  }
  return (
    <form className="fm-signup" onSubmit={join} noValidate data-testid="signup-form">
      <div className="fm-signup-row">
        <input ref={inputRef} type="email" className="fm-input fm-input-hero" placeholder="Your email address" aria-label="Your email address"
          value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" data-testid="signup-email-input" />
        <button type="submit" className="lv2-btn-hero fm-signup-btn" disabled={busy} data-testid="signup-submit-btn">
          {busy ? 'Joining…' : 'Become a founding member'}
        </button>
      </div>
      {error && <div className="fm-error fm-error-dark" role="alert" data-testid="signup-error">{error}</div>}
      <p className="fm-signup-note">Free to join. Founding members get a discounted price at launch.</p>
    </form>
  );
});
